export function useRecipeStore() {
  const i18n = useNuxtApp().$i18n
  const { locale } = i18n

  const isEn = computed<boolean>(() => locale.value === 'en')

  const recipeTypeOption = computed<{
    text: string
    value: number
  }[]>(() => {
    return [
      { text: isEn.value ? 'All' : '所有', value: 0 },
      { text: isEn.value ? 'Official Recipe' : '官方食谱', value: 1 },
      { text: isEn.value ? 'Member\'s Recipe' : '会员食谱', value: 2 },
      { text: isEn.value ? 'TOMIZ-Recipe' : 'TOMIZ-食谱', value: 3 },
    ]
  })

  return {
    recipeTypeOption,
  }
}
